import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Accordion,
  useColorModeValue,
} from '@chakra-ui/react';
import { FAQPresentationProps, FAQItem } from '../types';
import FAQItemPresentation from './FAQItemPresentation';
import { SectionAnchor } from '../../../shared/components';

const FAQPresentation: React.FC<FAQPresentationProps> = ({
  id,
  heading,
  description,
  faqItems
}) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  
  return (
    <>
      <SectionAnchor id={id} />
      <Box 
        as="section"
        pt={{ base: 4, md: 6 }} pb={{ base: 8, md: 12 }}
      >
      <Container maxW="container.lg">
        <VStack spacing={12} align="center">
          <Box textAlign="center" maxW="800px">
            <Heading 
              as="h2" 
              size="xl" 
              mb={4}
              bgGradient="linear(to-r, brand.primary.dark, brand.primary.base)"
              bgClip="text"
            >
              {heading}
            </Heading>
            <Text fontSize="lg" color="gray.600">
              {description}
            </Text>
          </Box>
          
          <Accordion allowToggle width="100%">
            {faqItems.map((item: FAQItem, index: number) => (
              <FAQItemPresentation 
                key={index}
                item={item}
                index={index}
                totalItems={faqItems.length}
                borderColor={borderColor}
              />
            ))}
          </Accordion>
        </VStack>
      </Container>
    </Box>
    </>
  );
};

export default FAQPresentation;